export var GET_ALERT_INIT = 'GET_ALERT_INIT';
export var GET_ALERT_SUCCESS = 'GET_ALERT_SUCCESS';
export var GET_ALERT_ERROR = 'GET_ALERT_ERROR';
export var GET_ALERT_DONE = 'GET_ALERT_DONE';
